export default {
	getById(id, cb, ecb, config) {
		this.http
			.get(`/shelf/getById/${id}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getByUser(uid, cb, ecb) {
		this.http
			.get(`/shelf/getByUser/${uid}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getBookProfileById(id, cb, ecb, config) {
		this.http
			.get(`/shelf/getBook/${id}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getByIds(ids, prof, cb, ecb, config) {
		this.http
			.get(`/shelf/getByIds/${ids}/${prof}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/shelf/search', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/shelf/update', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	random(shelfid, cb, ecb) {
		this.http
			.get(`/shelf/random/${shelfid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	recommend(bid, cb, ecb) {
		this.http
			.get(`/shelf/recommend/${bid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	recentAndTop(cb, ecb) {
		this.http
			.get('/shelf/recentAndTop')
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	addBook(form, cb, ecb) {
		this.http
			.post(`/shelf/addBook`, form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeBook(bfid, cb, ecb) {
		this.http
			.get(`/shelf/removeBook/${bfid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	onShelf(bfid, cb, ecb) {
		this.http
			.get(`/shelf/onShelf/${bfid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	offShelf(bfid, cb, ecb) {
		this.http
			.get(`/shelf/offShelf/${bfid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getManagers(shelfid, cb, ecb) {
		this.http
			.get(`/shelf/getManagers/${shelfid}`, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getUserGroup(shopid, cb, ecb) {
		this.http
			.get(`/shelf/getUserGroup/${shopid}`, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchBook(params, cb, ecb) {
		this.http
			.get('/shelf/searchBook', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchByISBN(isbn, cb, ecb) {
		this.http
			.get(`/shelf/searchByISBN/${isbn}`, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getBorrowById(id, cb, ecb) {
		this.http
			.get(`/shelf/getBorrowById/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchBorrow(params, cb, ecb) {
		this.http
			.get('/shelf/searchBorrow', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	countBorrow(params, cb, ecb) {
		this.http
			.get('/shelf/countBorrow', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	statusBorrow(id, to, cb, ecb) {
		this.http
			.get(`/shelf/statusBorrow/${id}/${to}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	confirmBorrow(id, cb, ecb) {
		this.http
			.get(`/shelf/confirmBorrow/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	returnBorrow(id, cb, ecb) {
		this.http
			.get(`/shelf/returnBorrow/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	}
}
